module.exports = __webpack_public_path__ + "img/icon1.4a3d596c.svg";